"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AolASPForm = exports.YahooASPForm = exports.ICloudASPForm = exports.GmailASPForm = void 0;

var _react = _interopRequireWildcard(require("react"));

var _get = _interopRequireDefault(require("lodash/get"));

var Yup = _interopRequireWildcard(require("yup"));

var _i18next = _interopRequireDefault(require("i18next"));

var _reactI18next = require("react-i18next");

var _formik = require("formik");

var _FormErrorMessage = _interopRequireDefault(require("../FormErrorMessage"));

var _CircularLoader = _interopRequireDefault(require("../CircularLoader"));

var _FormLabel = _interopRequireDefault(require("../FormLabel"));

var _Button = _interopRequireDefault(require("../Button"));

var _Input = _interopRequireWildcard(require("../Input"));

var _Text = require("./components/Text");

var _BrandLogo = _interopRequireDefault(require("./components/BrandLogo"));

var _Footer = _interopRequireDefault(require("./components/Footer"));

var baseSchema = {
  emailAddress: Yup.string().trim().email(_i18next["default"].t('retrofit.imap.emailAddress.error.invalid')).required(_i18next["default"].t('retrofit.imap.error.required')),
  password: Yup.string().trim().length(16).required(_i18next["default"].t('retrofit.imap.error.required'))
};

var BaseForm = function BaseForm(_ref) {
  var logo = _ref.logo,
      title = _ref.title,
      faqLink = _ref.faqLink,
      description = _ref.description,
      initialValues = _ref.initialValues,
      fields = _ref.fields,
      onSubmit = _ref.onSubmit,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  var formik = (0, _react.useRef)();

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  function handleOnSubmit(values) {
    Promise.resolve(onSubmit(values))["catch"](function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          field = _ref2.field,
          message = _ref2.message;

      var formikRef = formik.current;

      if (formikRef) {
        if (field && message) {
          formikRef.setFieldError(field, message);
        } else {
          formikRef.setFieldError('default', t('retrofit.imap.failure.denied'));
        }
      }
    });
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-w-screen-md"
  }, logo, /*#__PURE__*/_react["default"].createElement(_Text.Header, null, title), /*#__PURE__*/_react["default"].createElement(_Text.Description, null, description), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    ref: formik,
    enableReinitialize: true,
    onSubmit: handleOnSubmit,
    initialValues: initialValues,
    validationSchema: Yup.object().shape(baseSchema)
  }, function (_ref3) {
    var isValid = _ref3.isValid,
        values = _ref3.values,
        errors = _ref3.errors;
    return /*#__PURE__*/_react["default"].createElement(_formik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-xl mt-12 mb-24"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "pb-8"
    }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
      htmlFor: "emailAddress",
      className: "!text-base"
    }, fields.email.label), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
      autoFocus: true,
      disabled: fields.email.disabled,
      size: "lg",
      type: "text",
      name: "emailAddress",
      className: "w-full border-none mt-4",
      placeholder: fields.email.placeholder
    }), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
      name: "emailAddress"
    })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "leading-tight"
    }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
      htmlFor: "password",
      className: "!text-base"
    }, fields.password.label), /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-sm italic text-light"
    }, fields.password.description)), /*#__PURE__*/_react["default"].createElement(_Input.PasswordInput, {
      visibleToggle: true,
      size: "lg",
      length: "16",
      name: "password",
      type: "password",
      autocomplete: "off",
      Component: _Input.DigitInput,
      autoFocus: fields.email.disabled,
      className: "w-full border-none mt-5"
    }), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
      name: "password"
    }))), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
      name: "default",
      className: "py-4",
      showAfterTouch: false
    }), /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
      link: faqLink
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      type: "submit",
      className: "w-64",
      disabled: isLoading || !isValid
    }, isLoading ? /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], {
      fullWidth: true,
      size: 24,
      color: "inherit"
    }) : t('button.import'))));
  })));
};

var GmailASPForm = function GmailASPForm(_ref4) {
  var onSubmit = _ref4.onSubmit,
      isLoading = _ref4.isLoading,
      initialValues = _ref4.initialValues;

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  var fields = {
    email: {
      disabled: !!(0, _get["default"])(initialValues, 'emailAddress'),
      label: t('retrofit.imap.asp.default.email'),
      description: '',
      placeholder: 'example@gmail.com'
    },
    password: {
      disabled: false,
      label: t('retrofit.imap.asp.gmail.password'),
      description: t('retrofit.imap.asp.gmail.password.description'),
      placeholder: ''
    }
  };
  return /*#__PURE__*/_react["default"].createElement(BaseForm, {
    fields: fields,
    onSubmit: onSubmit,
    isLoading: isLoading,
    initialValues: initialValues,
    faqLink: t('gmailASPSite'),
    title: t('retrofit.imap.asp.title'),
    description: t('retrofit.imap.asp.gmail.description'),
    logo: /*#__PURE__*/_react["default"].createElement(_BrandLogo["default"], {
      provider: "google"
    })
  });
};

exports.GmailASPForm = GmailASPForm;

var ICloudASPForm = function ICloudASPForm(_ref5) {
  var onSubmit = _ref5.onSubmit,
      isLoading = _ref5.isLoading,
      initialValues = _ref5.initialValues;

  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation3.t;

  var fields = {
    email: {
      disabled: !!(0, _get["default"])(initialValues, 'emailAddress'),
      label: t('retrofit.imap.asp.default.email'),
      description: '',
      placeholder: 'username@example.com'
    },
    password: {
      disabled: false,
      label: t('retrofit.imap.asp.default.password'),
      description: t('retrofit.imap.asp.icloud.password.description'),
      placeholder: ''
    }
  };
  return /*#__PURE__*/_react["default"].createElement(BaseForm, {
    fields: fields,
    onSubmit: onSubmit,
    isLoading: isLoading,
    initialValues: initialValues,
    faqLink: t('icloudASPSite'),
    title: t('retrofit.imap.asp.title'),
    description: t('retrofit.imap.asp.icloud.description'),
    logo: /*#__PURE__*/_react["default"].createElement(_BrandLogo["default"], {
      provider: "icloud"
    })
  });
};

exports.ICloudASPForm = ICloudASPForm;

var YahooASPForm = function YahooASPForm(_ref6) {
  var onSubmit = _ref6.onSubmit,
      isLoading = _ref6.isLoading,
      initialValues = _ref6.initialValues;

  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation4.t;

  var fields = {
    email: {
      disabled: !!(0, _get["default"])(initialValues, 'emailAddress'),
      label: t('retrofit.imap.asp.default.email'),
      description: '',
      placeholder: 'username@example.com'
    },
    password: {
      disabled: false,
      label: t('retrofit.imap.asp.default.password'),
      description: t('retrofit.imap.asp.yahoo.password.description'),
      placeholder: ''
    }
  };
  return /*#__PURE__*/_react["default"].createElement(BaseForm, {
    fields: fields,
    onSubmit: onSubmit,
    isLoading: isLoading,
    initialValues: initialValues,
    faqLink: t('yahooASPSite'),
    title: t('retrofit.imap.asp.title'),
    description: t('retrofit.imap.asp.yahoo.description'),
    logo: /*#__PURE__*/_react["default"].createElement(_BrandLogo["default"], {
      provider: "yahoo"
    })
  });
};

exports.YahooASPForm = YahooASPForm;

var AolASPForm = function AolASPForm(_ref7) {
  var onSubmit = _ref7.onSubmit,
      isLoading = _ref7.isLoading,
      initialValues = _ref7.initialValues;

  var _useTranslation5 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation5.t;

  var fields = {
    email: {
      disabled: !!(0, _get["default"])(initialValues, 'emailAddress'),
      label: t('retrofit.imap.asp.default.email'),
      description: '',
      placeholder: 'username@example.com'
    },
    password: {
      disabled: false,
      label: t('retrofit.imap.asp.default.password'),
      description: t('retrofit.imap.asp.aol.password.description'),
      placeholder: ''
    }
  };
  return /*#__PURE__*/_react["default"].createElement(BaseForm, {
    fields: fields,
    onSubmit: onSubmit,
    isLoading: isLoading,
    initialValues: initialValues,
    faqLink: t('aolASPSite'),
    title: t('retrofit.imap.asp.aol.title'),
    description: t('retrofit.imap.asp.aol.description'),
    logo: /*#__PURE__*/_react["default"].createElement(_BrandLogo["default"], {
      provider: "aol"
    })
  });
};

exports.AolASPForm = AolASPForm;
//# sourceMappingURL=IMAPASPForm.js.map